<template>
  <div v-if="$store.getters.token" class="my-kyc">
    <ul class="kyc-tab-frame-m">
      <li class="tab-items-m verify-tab-items-m " @click="$router.push('/user/edit')">
        <i class="icon-arrow-back"><img :src="require(`@/assets/${$store.getters.currentTheme}/images/home-arrow-left.png`)" alt=""></i>
        {{ $t("Bao.return_user_page") }}
      </li>
    </ul>
    <!-- 驗證審核中 -->
    <div v-if="memberInfo.is_pass_KYC===2" class="verify-form">
      <p>
        <i class="icon-alert "><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-alert-kyc.png`)" alt=""></i>
        <span>{{ $t("Bao.kyc_verifydetail") }}</span>
        <br>
        <span>
          {{ $t("Bao.kyc_already") }}<span class="highlight"> {{ $t("Bao.kyc_audit") }}</span>。
        </span>
      </p>
    </div>
    <!-- 已驗證 -->
    <div v-if="memberInfo.is_pass_KYC===1" class="verify-form">
      <p>
        <i class="icon-alert "><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-alert-kyc.png`)" alt=""></i>
        <span>{{ $t("Bao.kyc_verifydetail") }}</span>
        <br>
        <span>
          {{ $t("Bao.kyc_already") }}<span class="highlight"> {{ $t("Bao.kyc_pass_verify") }}</span>。
        </span>
      </p>
    </div>
    <!-- 未經過驗證 -->
    <div v-if="memberInfo.is_pass_KYC===0" class="verify-form">
      <p>
        <i class="icon-alert "><img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-alert-kyc.png`)" alt=""></i>
        <span>{{ $t("Bao.kyc_verifydetail") }}</span>
        <br>
        <span>
          {{ $t("Bao.kyc_already") }}<span class="highlight"> {{ $t("Bao.kyc_upload_docs") }}</span>。
        </span>
      </p>
    </div>
    <br>

    <div class="kyc-bg">
      <div class="kyc-item unverified toggle" :class="{ active: activeItems['item1'], 'hide-h5': hideIdentity }">
        <h5 @click="toggleItem('item1')">
          {{ $t("Bao.kyc_idcard") }}
        </h5>
        <div class="kyc-content">
          <p>{{ $t("Bao.kyc_upload_below") }}<span class="highlight">{{ $t("Bao.kyc_oneof") }}</span>{{ $t("Bao.kyc_docs") }}</p>
          <div class="kyc-list">
            <ul class="ul_flex">
              <li>
                <button @click="setKYCUrl('Identity', 'driver')">
                  {{ $t("Bao.driver_selfie") }}
                </button>
              </li>
              <li>
                <button @click="setKYCUrl('Identity', 'numcard')">
                  {{ $t("Bao.numcard_selfie") }}
                </button>
              </li>
              <li>
                <button @click="setKYCUrl('Identity', 'passport')">
                  {{ $t("Bao.passport_selfie") }}
                </button>
              </li>
              <li>
                <button @click="setKYCUrl('Identity', 'debtcard')">
                  {{ $t("Bao.debtcard_selfie") }}
                </button>
              </li>
              <li>
                <button @click="setKYCUrl('Identity', 'esidentcard')">
                  {{ $t("Bao.esidentcard_selfie") }}
                </button>
              </li>
              <li>
                <button @click="setKYCUrl('Identity', 'eternal')">
                  {{ $t("Bao.eternal_selfie") }}
                </button>
              </li>
            </ul>
            <!-- <div class="upload-again">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/image-upload.png`)" alt="">
              <button class="button-style-14">
                <span>{{ $t("Bao.reupload") }}</span>
              </button>
            </div> -->
          </div>
          <p>{{ $t("Bao.kyc_forfast") }}</p>
          <ol class="disc">
            <li>{{ $t("Bao.kyc_complete") }}</li>
            <li>{{ $t("Bao.kyc_clear_photo") }}</li>
            <li>{{ $t("Bao.kyc_original") }}</li>
            <li>{{ $t("Bao.kyc_detailsend") }}</li>
          </ol>
          <p>{{ $t("Bao.selfie_with_idcard") }}</p>
          <ol>
            <li>{{ $t("Bao.kyc_camera") }}</li>
            <li>{{ $t("Bao.kyc_send_selfiecard") }}</li>
            <li>{{ $t("Bao.kyc_confirmself") }}</li>
          </ol>
          <!-- <p>請提交可作為身份證明的文件。詳情請查看<a href="" class="highlight">賬戶驗證頁面</a></p> -->
        </div>
      </div>
      <div class="kyc-item unverified toggle" :class="{ active: activeItems['item2'], 'hide-h5': hideAddress }">
        <h5 @click="toggleItem('item2')">
          {{ $t("Bao.kyc_address") }}
        </h5>
        <div class="kyc-content">
          <p>{{ $t("Bao.kyc_upload_below") }}<span class="highlight">{{ $t("Bao.kyc_oneof") }}</span>{{ $t("Bao.kyc_docs") }}</p>
          <div class="kyc-list">
            <ul class="ul_flex">
              <li>
                <button
                  @click="setKYCUrl('Address', 'residence')"
                >
                  {{ $t("Bao.residence_permit") }}
                </button>
              </li>
              <li>
                <button
                  @click="setKYCUrl('Address', 'utility')"
                >
                  {{ $t("Bao.utility_bill") }}
                </button>
              </li>
              <li>
                <button
                  @click="setKYCUrl('Address', 'credit')"
                >
                  {{ $t("Bao.credit_bill") }}
                </button>
              </li>
            </ul>
            <!-- <div class="upload-again">
              <img :src="require(`@/assets/${$store.getters.currentTheme}/images/image-bank.png`)" alt=""><button class="button-style-14">
                <span>重新上傳</span>
              </button>
            </div> -->
          </div>
          <p>手持ちの撮影は不要ですが、上記の中から1つの書類と「勝win認証用および提出日当日の日付」を記載した紙と一緒に、正面から全体が写るように撮影ください。</p>
          <p>{{ $t("Bao.kyc_forfast") }}</p>
          <ol class="disc">
            <li>住所確認用書類は発行日が3か月以内のもの。</li>
            <li>お客様の氏名と住所が一枚の書類上に記載されているもの。</li>
            <li>住所確認用書類の四隅がきちんと範囲内に撮影されているもの。</li>
            <li>当サイトのアカウント登録時の住所と一致している必要がございます。 書類をアップロードされる前に、ご登録の住所などが最新のものか今一度ご確認ください。</li>
            <li>{{ $t("Bao.kyc_complete") }}</li>
            <li>提出書類は3ヶ月以内に発行されたもの。</li>
            <li>{{ $t("Bao.kyc_detailsend") }}</li>
            <li>{{ $t("Bao.kyc_send_selfiecard") }}</li>
            <li>お客様の個人情報が確認できる写真。(全ての書類はお客様ご本人の名義である事が必須条件でございます。当サイトではご本人以外のお名前の物は一切受け取りいたしかねますので、ご留意ください。)</li>
            <li>{{ $t("Bao.kyc_original") }}</li>
            <li>建物名や部屋番号などを含むすべてての情報がお客様のアカウントの住所と一致している必要がございます。アカウント設定画面でお客様のアカウント情報はご確認いただけます。</li>
            <li>注意：携帯電話等のカメラで撮影した画像のみを受け付けます。スキャナで取り込んだ画像や、デジタル化、編集処理されたものは一切認められません。</li>

            <!-- <li>{{ $t("Bao.kyc_clear_photo") }}</li>
            <li>{{ $t("Bao.kyc_three_months") }}</li>

            <li>{{ $t("Bao.kyc_self_prove") }}</li>
            <li>{{ $t("Bao.kyc_info_prove") }}</li> -->
          </ol>
        </div>
      </div>
      <div class="kyc-item toggle" :class="{ active: activeItems['item3'], 'hide-h5': hideOthers }">
        <h5 @click="toggleItem('item3')">
          {{ $t("Bao.send_additional") }}
        </h5>
        <div class="kyc-content">
          <p> {{ $t("Bao.kyc_additional") }}</p>
          <div class="kyc-list">
            <ul class="ul_flex">
              <li>
                <button
                  class="button-style-14"
                  @click="setKYCUrl('Others', 'none')"
                >
                  <span>{{ $t("Bao.select_file_photo") }}</span>
                </button>
              </li>
            </ul>

            <!-- <i> <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-kyc-add.png`)" alt=""></i> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="notice">
     {{ $t("Bao.kyc_lack") }}
    </p> -->
    <div v-show="isModalOpen" class="popup-wrap" :class="{ active: isModalOpen }">
      <div class="popup-box">
        <iframe class="fullscreen-iframe" :src="KYCUrl" @load="iframeLoaded" />
        <a v-if="isIframeLoaded" class="popup-close" @click="closeIframe" />
      </div>
    </div>
  </div>
</template>

<script>
import { KycReview } from '@/api/user'
import { getFullDomain } from '@/utils/tool'

export default {
  data() {
    return {
      activeItems: {},
      KYCUrl: null,
      KYCVer: process.env.VUE_APP_KYC_VER,
      isModalOpen: false,
      isIframeLoaded: false,
      currentType: null
    }
  },
  computed: {
    memberInfo() {
      return this.$store.state.user.memberInfo
    },
    hideIdentity() {
      return this.shouldHide('Identity')
    },
    hideAddress() {
      return this.shouldHide('Address')
    },
    hideOthers() {
      return this.shouldHide('Others')
    }
  },
  watch: {
    'memberInfo.is_pass_KYC': function(newValue, oldValue) {
      if (newValue === 0) {
        localStorage.removeItem('kycTypes')
      }
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage)
  },
  methods: {
    setKYCUrl(type, subType) {
      this.currentType = type
      this.isIframeLoaded = false
      this.KYCUrl = ''
      const domain = getFullDomain()

      setTimeout(() => {
        this.KYCUrl = `https://script.google.com/macros/s/${this.KYCVer}/exec?brand=${this.memberInfo.brand_id}&promotion=${this.memberInfo.promotion_code}&type=${type}&subtype=${subType}&lang=${this.$store.state.user.language}&domain=${domain}`
      }, 30)
      this.isModalOpen = true
    },
    receiveMessage(event) {
      if (event.data === 'uploadSuccess') {
        // Store the current type in localStorage
        const existingTypes = JSON.parse(localStorage.getItem('kycTypes') || '[]')
        if (!existingTypes.some(item => item.type === this.currentType)) {
          existingTypes.push({ type: this.currentType })
          localStorage.setItem('kycTypes', JSON.stringify(existingTypes))
        }

        KycReview(this.memberInfo.id).then(response => {
          // SET memberInfo.is_pass_KYC from 0 to 2, 未通過 => 審核中
          console.log(response)
        }).catch(error => {
          console.error('Error, KycReview:', error)
        })
      }
    },
    shouldHide(type) {
      const existingTypes = JSON.parse(localStorage.getItem('kycTypes') || '[]')
      const typeExists = existingTypes.some(item => item.type === type)
      return this.memberInfo.is_pass_KYC === 2 && typeExists || this.memberInfo.is_pass_KYC === 1
    },
    iframeLoaded() {
      this.isIframeLoaded = true
    },
    toggleItem(index) {
      if (index === 'item1' && this.hideIdentity) return
      if (index === 'item2' && this.hideAddress) return
      if (index === 'item3' && this.hideOthers) return
      this.$set(this.activeItems, index, !this.activeItems[index])
    },
    closeIframe() {
      this.isModalOpen = false
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.popup-box{
    width: 80vw;
    max-width: 800px;
    height: 40vh;
}
.fullscreen-iframe {
  width: 100%;
  height: 360px;
  border-radius: 10px;
}
.hide-h5 > h5 {
  background-image:none !important;
}

@media (max-width: 600px){
.popup-box{
   width: 80vw;
   height: 40vh;
}
}
.ul_flex{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
</style>
